import React from "react";
import { Alert } from "react-bootstrap";

interface FormErrorDisplayProps {
  errors: string[] | undefined;
}

function FormErrorDisplay({ errors }: FormErrorDisplayProps) {
  if (errors)
    return (
      <div style={{ marginTop: "1rem" }}>
        {errors.map((e, index) => (
          <Alert key={e} variant="danger">
            <p>{e}</p>
          </Alert>
        ))}
      </div>
    );
  else return <></>;
}

export default FormErrorDisplay;
